import { API } from "../api/axios";
const END_POINT = "/events";
const END_POINT_EVENT ="/event";
const END_POINT_EVENT_COMMING ="/dashboard/event-nearest";
class EventService {
    getAll(params) {
        return API.get(END_POINT, params);
    }
    getComming() {
        return API.get(`${END_POINT_EVENT_COMMING}`);
    }
    get(id){
        return API.get(`${END_POINT_EVENT}/${id}`)
    }
    delete(id) {
        return API.delete(`${END_POINT_EVENT}/${id}`);
    }
    create(data) {
        return API.post(END_POINT_EVENT, data);
    }
    update(id, data) {
        return API.post(`${END_POINT_EVENT}/${id}`, data);
    }
}

export default new EventService();
